<template>
  <CustomPage
    :title="pageType === 'create' ? '新增地址' : '修改地址'"
    right-text="保存"
    @onClickRight="onSubmit"
  >
    <div slot="content" class="content">
      <Form ref="form">
        <Field
          readonly
          :value="form.areaName"
          label="所在地区"
          placeholder="点击选择省市区"
          right-icon="arrow"
          @click="showArea = true"
          :rules="[
            { required: true, trigger: 'onBlur', message: '请输入省市区' },
          ]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          v-model="form.address"
          label="详细地址"
          placeholder="请填写详细地址"
          input-align="right"
          :rules="[
            { required: true, trigger: 'onBlur', message: '请输入详细地址' },
          ]"
          error-message-align="right"
        />
        <Field
          v-model="form.name"
          label="联系人"
          placeholder="请输入联系人姓名"
          :rules="[{ validator: vaildName, message: '请正确输入姓名' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          v-model="form.phone"
          label="联系方式"
          placeholder="请输入联系方式"
          :rules="[{ validator: validPhone, message: '请正确输入手机号' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          label="设置成为默认地址"
          input-align="right"
          label-class="defaultFlagLabel"
        >
          <template #input>
            <Checkbox
              :value="form.defaultFlag"
              @input="checkboxClick"
              checked-color="#E82035"
            />
          </template>
        </Field>
      </Form>
      <Popup v-model="showArea" position="bottom">
        <Area
          :value="form.area"
          :area-list="areaList"
          @confirm="AreaConfirm"
          @cancel="showArea = false"
        />
      </Popup>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import { areaList } from '@vant/area-data'
import { addAddress } from '@/api/setting/address'
import { vaildName, validPhone } from '@/utils/vaildate'
import { Form, Field, Popup, Area, Checkbox, Notify } from 'vant'
export default {
  components: { CustomPage, Form, Field, Popup, Area, Checkbox },
  data() {
    return {
      pageType: 'create',
      areaList,
      vaildName,
      validPhone,
      showArea: false,
      id: this.$route.query.id,
      form: {
        area: null,
        areaName: null,
        city: null,
        province: null,
        address: null,
        name: null,
        phone: null,
        defaultFlag: false,
      },
    }
  },
  created() {
    if (this.$route.query.data) {
      const data = JSON.parse(this.$route.query.data)
      if (data.id) {
        this.pageType = 'edit'
        this.id = data.id
        for (const key in this.form) {
          if (Object.hasOwnProperty.call(this.form, key)) {
            if (['province', 'city', 'area'].indexOf(key) >= 0) {
              this.form[key] = data[key].toString()
              continue
            }
            this.form[key] = data[key]
          }
        }
        const province = this.areaList.province_list[data.province]
        const city = this.areaList.city_list[data.city]
        const county = this.areaList.county_list[data.area]
        this.form.areaName = `${province} ${city} ${county}`
      }
    }
  },

  methods: {
    onSubmit() {
      this.$refs.form
        .validate()
        .then((res) => {
          this.submitForm()
        })
        .catch((err) => {
          Notify('信息填写有误')
        })
    },
    submitForm() {
      const params = this._.cloneDeep(this.form)
      delete params.areaName
      params.customerId = this.$store.state.user.customerId
      if (this.pageType === 'edit') {
        params.id = this.id
      }
      this.$store.dispatch('app/showLoading')
      addAddress(params)
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          const message = {
            create: '新增成功',
            edit: '编辑成功',
          }
          Notify({ type: 'success', message: message[this.pageType] })
          this.$router.back()
        })
        .catch((err) => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    AreaConfirm(val) {
      const list = val.map((item) => item.name)
      this.form.areaName = list.join(' ')
      this.form.province = val[0]['code']
      this.form.city = val[1]['code']
      this.form.area = val[2]['code']
      this.showArea = false
    },
    checkboxClick(e) {
      this.form.defaultFlag = e
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  .van-form {
    .van-cell {
      font-size: 28px;
      line-height: 1em;
      padding: 28px 24px;
      /deep/ .van-field__label {
        color: #333333;
      }
      /deep/ .defaultFlagLabel {
        width: 400px;
      }
      &::after {
        border-color: #f2f2f2;
      }
    }
  }
}
</style>
